export const SET_EMPLOYEES = "EMPLOYEE/SET_EMPLOYEES";
export const SET_EMPLOYEE = "EMPLOYEE/SET_EMPLOYEE";
